<template>
  <router-link
    :to="url"
    tag="li"
    class="nav-item nav-dropdown"
    disabled>
    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
      <i :class="classIcon" /> 
      {{ name }}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{ badge.text }}</b-badge>
    </div>
    <ul class="nav-dropdown-items">
      <slot />
    </ul>
  </router-link>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    badge: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    classIcon() {
      return ["nav-icon", this.icon];
    }
  },
  methods: {
    handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle("open");
    }
  }
};
</script>

<style scoped lang="css">
.nav-link {
  cursor: pointer;
}
</style>
